export function TutorialsClientCardsContainer(props) {
    return (
        <section className="content" style={{ marginTop: '30px' }}>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="card card-outline card-info">
                            <div className="card-header">
                                <h3 className="card-title">{props.icon || <i className='fa-solid fa-pen-to-square mr-1'></i>}{props.labelTitle}</h3>
                            </div>
                            {props.children}
                        </div>
                    </div>
                </div>
            </div>
      </section>
    )
}